'use client';

import React from 'react';
import { gtStandard, gtStandardS } from 'fonts';
import 'styles/app.css';
import CtaChevron from 'components/commercetools-ui/organisms/home-brand-refresh/cta-chevron';
import { brandAssetAt } from 'helpers/brandAssets';

// Error boundaries must be Client Components, and global-error replaces the root layout, so the
// brand fonts and shell are applied here directly. Copy is hard-coded: the i18n provider is not
// available inside an error boundary.
export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="en" className={`${gtStandard.variable} ${gtStandardS.variable}`}>
      <body className="bg-white font-gt text-[#212121]">
        <header className="flex h-64 items-center bg-[#212121] px-24 md:px-38">
          <a href="/" aria-label="Viewrail">
            <img src={brandAssetAt('logo-wordmark.png', 284)} alt="Viewrail" width={142} height={17} />
          </a>
        </header>

        <main className="w-full px-24 py-64 md:px-38 md:py-96">
          <div className="max-w-screen-md">
            <p className="text-12 font-bold uppercase text-[#5e5e5e]">Something went wrong</p>
            <h1 className="mt-12 text-32 font-medium leading-[1.2] md:text-48">This page isn&apos;t working</h1>
            <p className="mt-16 text-16 leading-[1.5] text-[#5e5e5e] md:mt-24">
              We&apos;re having trouble on our end. Try again in a moment, or reach our team and we&apos;ll get you
              sorted.
            </p>
            <div className="mt-32 flex flex-col gap-16 md:flex-row md:items-center md:gap-32">
              <button
                type="button"
                onClick={reset}
                className="inline-flex h-44 items-center justify-center bg-[#1c1c1c] px-32 text-14 text-white transition-opacity hover:opacity-90"
              >
                Try Again
              </button>
              <a
                href="https://www.viewrail.com/support/"
                className="flex min-h-44 items-center font-gt-s text-14 font-bold text-[#191919] hover:underline"
              >
                Contact Customer Support
                <CtaChevron />
              </a>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
